import React from "react";
import Logo from '../../assets/Logo (1).png'


import {
  FaTwitter,
  FaDribbble,
  FaLinkedin,
  FaFigma,
  FaYoutube,
} from "react-icons/fa";
export const LeftSide = () => {
  return (
    <div className="py-6 w-auto">
      <a href="/">
              <img src={Logo} alt="" />
      
            </a>
      <p className="py-4 w-3/4">
        A constantly evolving platform of user-friendly flows that empowers
        designers to craft meaningful stunning mobile apps.
      </p>
      <div className="flex space-x-6 items-center text-xl">
        <FaDribbble className="text-2xl" />
        <FaLinkedin className="text-2xl"/>
        <FaYoutube className="text-2xl"/>
        <FaTwitter className="text-2xl"/>
        <FaFigma className="text-2xl"/>
      </div>
    </div>
  );
};
